module.exports = __webpack_public_path__ + "img/album18_29.30a71743.jpg";